import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'modules.Catalog.pages.Products.pages.pageTitle',
    defaultMessage: 'Produtos',
  },
  pageSubtitle: {
    id: 'modules.Catalog.pages.Products.pages.pageSubtitle',
    defaultMessage:
      'Todos os produtos adicionados em sua loja, com os detalhes sobre o Pedido mínimo, Valor e se estão publicados para os lojistas comprarem',
  },
  bulkUpdate: {
    id: 'modules.Catalog.pages.Products.pages.bulkUpdate',
    defaultMessage: 'Editar produtos em massa',
  },
});

export default messages;
